export const typography = {
  fontFamily: {
    primary: 'Roboto',
    secundary: 'Source Sans Pro',
  },
};
